import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { formattedDate, options } from '@utils/utilityFunctions';



const VIGENCIACORTE: string = '21/03/' + formattedDate.getFullYear();


function Vigency({ isPayment= false }) {
  // @ts-ignore
  function validarFechaEnRango() {
    const fecha = new Date();
    const day = fecha.getDate();
    const mes = fecha.getMonth();
    if (day <= 20 && mes + 1 === 2) {
      return true;
    } else {
      return false;
    }
  }

  const stringADate = (fechaString: string): Date => {
    const [day, month, year] = fechaString.split('/').map(Number);
    return new Date(year, month - 1, day);
  };





  const validarFechaFin = (fechaInicio: Date, fechaFinBase: Date): Date => {
    // Normalizar fechas (sin horas)
    const inicio = new Date(
      fechaInicio.getFullYear(),
      fechaInicio.getMonth(),
      fechaInicio.getDate()
    );
    const finBase = new Date(
      fechaFinBase.getFullYear(),
      fechaFinBase.getMonth(),
      fechaFinBase.getDate()
    );

    console.log(' Fecha inicio:', inicio.toLocaleDateString('es-ES'));
    console.log(' Fecha fin base:', finBase.toLocaleDateString('es-ES'));



    if(inicio > finBase){
      // Calcular nueva fecha: fechaInicio + 1 año
      const nuevaFechaFin = new Date(finBase);
      nuevaFechaFin.setFullYear(nuevaFechaFin.getFullYear() + 1);

     /* console.log(' Fecha inicio es anterior - Se calcula nueva fecha fin');
      console.log(
        ' Nueva fecha fin calculada:',
        nuevaFechaFin.toLocaleDateString('es-ES')
      );*/
      return nuevaFechaFin;
    }

    // Si la fecha de inicio es MAYOR o IGUAL a la fecha fin base
    // (la póliza empieza después o igual a lo calculado)
   /* console.log(
      'Fecha inicio es posterior o igual - Se usa fecha fin base como corte'
    );*/
   // console.log(' Fecha fin (corte):', finBase.toLocaleDateString('es-ES'));

    return new Date(finBase);
  };





  const vigencyBegin: string = formattedDate.toLocaleString('es-ES', options);

  const nextYear = new Date(formattedDate);
  nextYear.setFullYear(formattedDate.getFullYear() + 1);


  //const vigencyBegin: string = '22/03/2029';
  const fechaInicio:Date=  stringADate(vigencyBegin);
  const fechaFin: Date = stringADate(VIGENCIACORTE);
  const endFinal: Date = validarFechaFin(fechaInicio, fechaFin);
 /* console.log(
    ' Nueva fecha fin calculada:==>',
    endFinal.toLocaleDateString('es-ES')
  );*/
  const vigencyEndBaseStr: string = endFinal.toLocaleDateString(
    'es-ES',
    options
  );







   return (
     <Box
       sx={{
         width: { xs: 'auto', md: isPayment ? '100%' : 'auto' },
         margin: { xs: '24px 0px 20px 0px', md: '0px 0px 20px 0px' },
       }}
     >
       <Typography fontWeight="700" fontSize="16px">
         Vigencia
       </Typography>
       <Box
         sx={{
           width: { xs: 'auto', md: isPayment ? '100%' : 'auto' },
           display: 'flex',
           padding: '24px 16px',
           marginTop: { xs: '4px' },
           flexDirection: 'column',
           gap: '24px',
           borderRadius: '8px',
           background: 'var(--White, #FFF)',
           boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.12)',
         }}
       >
         <Stack direction={'row'} justifyContent={'space-between'}>
           <Typography fontWeight="400" fontSize="18px">
             Inicio:
           </Typography>
           <Typography fontWeight="400" fontSize="18px">
             {`${vigencyBegin}`}
           </Typography>
         </Stack>
         <Stack direction={'row'} justifyContent={'space-between'}>
           <Typography fontWeight="400" fontSize="18px">
             Término:
           </Typography>
           <Typography fontWeight="400" fontSize="18px">
             {validarFechaEnRango() === true
               ? `${nextYear.toLocaleString('es-ES', options)}`
               : `${vigencyEndBaseStr}`}
           </Typography>
         </Stack>
       </Box>
     </Box>
   );
}
export default Vigency;